export default "https://cdn-static.gokick.com/assets/0ba7a9ad4dd7229a35aca69ca4183ecb31843a51/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";